import {api} from './api';
import {AccessKeyRecord} from '../common/sharedView';

export enum RepositoryAccessKeyType {
	Schema = 'schema',
	Read = 'read',
}

export type RepositoryAccessKeyRecord = AccessKeyRecord & {
	repositoryId: string;
	type: RepositoryAccessKeyType;
};

export const repositoryAccessKeysApi = api.injectEndpoints({
	endpoints: (builder) => ({
		repositoryAccessKeysFind: builder.query<RepositoryAccessKeyRecord[], {repositoryId: string, type: RepositoryAccessKeyType}>({
			query: (params) => ({
				url: 'repository-access-keys/find',
				params,
			}),
			extraOptions: {maxRetries: 0},
		}),
		repositoryAccessKeyGenerate: builder.mutation<RepositoryAccessKeyRecord, {repositoryId: string, type: RepositoryAccessKeyType}>({
			query: (body) => ({
				url: 'repository-access-keys/generate',
				method: 'POST',
				body,
			}),
			extraOptions: {maxRetries: 0},
		}),
		repositoryAccessKeyDelete: builder.mutation<void, {shareLinkId: string}>({
			query: ({shareLinkId}) => ({
				url: `repository-access-keys/${shareLinkId}`,
				method: 'DELETE',
			}),
			extraOptions: {maxRetries: 0},
		}),
	}),
});

export const {
	useRepositoryAccessKeysFindQuery,
	useRepositoryAccessKeyGenerateMutation,
	useRepositoryAccessKeyDeleteMutation,
} = repositoryAccessKeysApi;
